import util from '@bmp-vue/core/api/util';
const controller = 'Imagem';
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  atualizaCorImagem (imagem, corAtual, corNova) {
    if (!imagem || !Array.isArray(imagem.cor)) return;
    imagem.cor = imagem.cor.map(cor =>
      cor.toLowerCase() === corAtual.toLowerCase() ? corNova : cor
    );
    return imagem;
  },
  atualizaURLImagem (url, novoCaminhoS3) {
    const partes = url.split('/');
    partes.pop();
    const novaURL = partes.join('/') + '/' + encodeURIComponent(novoCaminhoS3);
    return `${novaURL}?v=${Date.now()}`;
  },
  extrairCoresDoSVG (svgTexto) {
    const regex = /fill="([^"]*)"/gi;
    var cores = [];
    var match;
    const ctx = document.createElement('canvas').getContext('2d');
    while ((match = regex.exec(svgTexto)) !== null) {
      var cor = match[1].trim();
      if (/^#([0-9a-f]{3}){1,2}$/i.test(cor)) {
        if (cor.toLowerCase() !== 'none') {
          cores.push(cor.toUpperCase());
        }
      } else {
        ctx.fillStyle = cor;
        var computed = ctx.fillStyle;
        if (computed.startsWith('rgb')) {
          const rgb = computed.match(/\d+/g).map(Number);
          const hex = '#' + rgb.map(x => x.toString(16).padStart(2, '0')).join('').toUpperCase();
          if (hex !== '#000000' || cor.toLowerCase() === 'black') {
            cores.push(hex);
          }
        }
      }
    }
    cores = [...new Set(cores)]
    return cores.filter(c => c.toLowerCase() !== 'none');
  }
});
